import React from 'react'
import liveStatus from '../../data/liveStatus.json'
import { stringToSEO } from '../../utils/stringOps'

function ShowAuthorities ({ authorities }) {
  authorities = Array.from(new Set(authorities.map(a => a.id)))
    .map(id => {
      return authorities.find(a => a.id === id)
    })

  var authorityType = authorities.filter(x => x.liveStatus !== 0)[0] ? 'major' : 'standard'
  
  return (
    <>
      {(authorities.length > 0) ? (
        <div className='article-authorities box-container'>
          <div className='box-header'>Authorities</div>
          <div className='box-inner'>
            {authorities.map(content =>
              (
                <div className='authority-item item-content' key={content.id}>
                  <div className={`item-data item-data-${authorityType}`}>
                    <b>{content.geoNames}</b>
                    <div><a href={`/#/content/${content.id}/${stringToSEO(content.title)}?referrer=portfolio_related_entityindividual`} rel='noopener noreferrer' target='_self'>{content.title}</a></div>
                    {(content.caseId != undefined && content.caseId.length > 0) ? <div>{content.caseId}</div> : null }
                  </div>
                  <div className={`item-status item-status-${authorityType}`}>
                    {liveStatus.filter(x => x.id === content.liveStatus)[0]
                      ? <div aria-label={liveStatus.filter(x => x.id === content.liveStatus)[0].description} className={`tooltip status-block ${liveStatus.filter(x => x.id === content.liveStatus)[0].color}`}><span className='status-name'>{liveStatus.filter(x => x.id === content.liveStatus)[0].name}</span><span className='status-status'>{liveStatus.filter(x => x.id === content.liveStatus)[0].status}</span></div>
                      : <div />}
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default ShowAuthorities
